/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { OptionButton } from '../../../../utils/Button';
import { TableSortArrow } from '../../../../utils/IconComp';
import InstOption from '../../../../utils/InstOption';
import { GetDate } from '../../../../utils/Show';
import { TextCapitalize } from '../../../../utils/TextFormatter';
import { mkRelativeUrl } from '../../../../utils/URL';
import cn from '../../../../utils/cn';
import { useAdminListInfo } from '../AdminsListProvider';

function TableRow({ item }) {
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState(false);
    const {
        handleCustomerTypeModal,
        handleCustomerStatusModal,
        handleShowEditModal,
        handleDisable2FA
    } = useAdminListInfo();

    const handleShowInstMenu = (e) => {
        e.stopPropagation();
        setShowMenu((d) => !d);
    };

    const isActive = item?.status === 'active';
    return (
        <tr className={cn(`group`, { 'placeholder-mode': item?.demo })}>
            <td>
                <span>{item?.id}</span>
            </td>

            <td
                onClick={() => navigate(mkRelativeUrl(`/settings/admins/${item?.id}/info`))}
                className="cursor-pointer group-hover:text-secondary hover:underline"
            >
                <span className="text-ellipsis overflow-hidden w-full block first-letter:!uppercase group-hover:font-medium">
                    {item?.fullName || '-----'}
                </span>
                {/* item?.permissions.find admin.manager then show super admin */}
                {item?.permissions?.includes('admin.manager') && (
                    <span className="text-xs text-secondary">Super Admin</span>
                )}
            </td>
            <td>
                <span className="text-ellipsis overflow-hidden w-full block">
                    {item?.primaryEmail || '------'}
                </span>
            </td>

            <td>
                <span className={item?.timeCreated ? '' : 'w-3/5 inline-block text-center'}>
                    {GetDate(item?.timeCreated) || '--'}
                </span>
            </td>
            <td className="text-left">
                <p className="font-medium">
                    {/* {item?.permissions?.map((d) => d)?.join(', ') || '--'} */}
                    {item?.permissions?.slice(0, 2)?.map((d) => {
                        return (
                            <span
                                key={d}
                                className="bg-secondary-200 p-1 px-2 rounded-5 mr-1 text-xs text-secondary"
                            >
                                {TextCapitalize(d)}
                            </span>
                        );
                    })}
                    {item?.permissions?.length > 2 ? (
                        <Link
                            to={mkRelativeUrl(`/settings/admins/${item?.id}/info`)}
                            className="mt-1 block text-secondary text-xs underline"
                        >
                            More..
                        </Link>
                    ) : null}
                </p>
            </td>
            <td className="text-center capitalize">
                <span className={item?.tfaEnabled ? 'text-secondary' : 'text-error'}>
                    {item?.tfaEnabled ? 'Enabled' : 'Disabled'}
                </span>
            </td>
            <td className="text-center capitalize">
                <span className={isActive ? 'text-secondary' : 'text-warning'}>{item?.status}</span>
            </td>
            <td className="text-center !pr-5">
                <div className="flex flex-row w-full justify-end relative">
                    <OptionButton onClick={handleShowInstMenu} />

                    <InstOption showMenu={showMenu} setShowMenu={setShowMenu}>
                        <button
                            type="button"
                            onClick={() =>
                                navigate(mkRelativeUrl(`/settings/admins/${item?.id}/info`))
                            }
                        >
                            Manage
                        </button>
                        {isActive && (
                            <button type="button" onClick={(ev) => handleShowEditModal(ev, item)}>
                                Edit Info
                            </button>
                        )}

                        {isActive && (
                            <button
                                type="button"
                                onClick={(ev) => handleCustomerTypeModal(ev, item)}
                            >
                                Change Role
                            </button>
                        )}
                        <button type="button" onClick={(ev) => handleCustomerStatusModal(ev, item)}>
                            {item?.status === 'active' ? 'Make Inactive' : 'Make Active'}
                        </button>

                        {item?.tfaEnabled && isActive && (
                            <button type="button" onClick={(ev) => handleDisable2FA(ev, item.id)}>
                                Disable 2FA
                            </button>
                        )}
                    </InstOption>
                </div>
            </td>
        </tr>
    );
}

function TableHeader({ handleSortingData, sortedColumn, sortBy }) {
    return (
        <thead>
            <tr>
                <th onClick={() => handleSortingData('id')} scope="col">
                    <span className="uppercase">Id</span>
                    <TableSortArrow name="id" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>

                <th onClick={() => handleSortingData('name')} scope="col">
                    <span>Name</span>
                    <TableSortArrow name="name" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th scope="col" className="!cursor-default">
                    <span>Email</span>
                </th>

                <th onClick={() => handleSortingData('created')} scope="col" className="w-32 !px-1">
                    <span>Date Created</span>
                    <TableSortArrow name="created" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th scope="col" className="w-52 text-left !cursor-default">
                    <span>Permissions</span>
                </th>
                <th scope="col" className="w-30 text-center !cursor-default">
                    <span>2FA</span>
                </th>
                <th
                    onClick={() => handleSortingData('status')}
                    scope="col"
                    className="text-center w-20 !px-0"
                >
                    <span>Status</span>
                    <TableSortArrow name="status" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th scope="col">#</th>
            </tr>
        </thead>
    );
}

function PageTable({ data, handleSortingData, sortedColumn, sortBy }) {
    return (
        <div className="customer_page_table mb-52">
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <TableHeader
                    handleSortingData={handleSortingData}
                    sortedColumn={sortedColumn}
                    sortBy={sortBy}
                />
                <tbody className="">
                    {data && data?.length === 0 && (
                        <tr className="border-b border-[#1B1B1F]/10 h-12.5">
                            <td colSpan={8} className="!text-left">
                                <span className="text-primary-700 ">No Admins Found!</span>
                            </td>
                        </tr>
                    )}
                    {data?.map((item) => (
                        <TableRow key={item?.id} item={item} />
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default PageTable;
